import { IConfiguration } from "../models/app/IConfiguration";

export const CONFIGURATION: IConfiguration = {
	components: {
		app: {
			cardProps: {
				props: {
					title: "tabs",
				},
				queries: {},
			},
			activeTabManagement: {
				initialValue: {
					queryOptionsType: 'url',
					options: {
						url: {
							code: 'param',
							urlPattern: {
								queryOptionsType: 'none',
								options: {
									none: {
										value: '/:activeTab',
									},
								},
							},
							key: 'activeTab',
						},
					},
				},
				urlRewrite: {
					defaultUrl: '/{activeTab}',
					options: {
						preserveOrigin: true,
					}
				}
			},
		},
		tabs: {
			breakpoints: [
				{
					size: "small",
					modifier: "down",
					props: {
						activeTab: "chart",
						children: [
							{
								tabKey: "chart",
								header: "small down",
								icon: {
									align: "right",
									asset: "base.accordionPanel.expandIcon",
								},
								content: [
									{
										templateId: "ksys-app-bar-chart",
										configurationKey: "sectorExposure",
										applicationCode: "4196bae9-2fb1-4fa8-9fc0-4fd996a64442",
									},
								],
							},
						],
					},
				},
				{
					size: "medium",
					modifier: "up",
					props: {
						activeTab: "chart",
						// headersMode: 'dropdown',
						children: [
							{
								tabKey: "chart",
								header: "Chart",
								icon: {
									align: "right",
									asset: "base.accordionPanel.expandIcon",
								},
								content: [
									{
										templateId: "ksys-app-bar-chart",
										configurationKey: "sectorExposure",
										applicationCode: "4196bae9-2fb1-4fa8-9fc0-4fd996a64442",
									},
								],
							},
							{
								tabKey: "table",
								header: "Table",
								icon: {
									align: "right",
									asset: "base.accordionPanel.collapseIcon",
								},
								content: [
									{
										templateId: "ksys-app-table",
										configurationKey: "sectorExposure",
										applicationCode: "3164f959-f989-4667-aa4a-4be5b7773bf7",
									},
								],
							},
						],
					},
				},
			],
		},
	},
};
